export default class Answer {
    constructor(id, question, index, value){
        this.id = id;
        this.question = question;
        this.index = index;
        this.value = value;
    }
}